<template>
    <div id="top-content-container">
        <transition name="fade" mode="out-in">
            <router-view :key="$route.path" :search="search"></router-view>
        </transition>
    </div>
</template>

<script>
export default {
    props: ["search"],
    name: "contentcontainer",
    computed: {},
    data() {
        return {}
    },
    components: {},
    methods: {}
}
</script>

<style>
</style>



